import React from "react";
import styles from "./Pointer.module.css";

interface PointerProps {
  onClick: () => void;
}

const Pointer: React.FC<PointerProps> = ({ onClick }) => {
  return (
    <div className={styles.pointer} onClick={onClick}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7 10L12 15L17 10"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};

Pointer.displayName = "Pointer";

export default Pointer;
